<template>
  <div class="text-[10px] text-blue mt-6">
    ©
    <span class="font-bold">{{ $t('Zorgblik ') + new Date().getFullYear() }}</span>
    - {{ $t('Made by STRIXI') }}
  </div>
</template>
